import {FC} from "react";
import {InvitedUser} from "../../../../types/domain.ts";
import {Table, TableProps} from "antd";
import {getUserOrigin} from "../../../../utils/getUserOrigin.ts";

type Props = {
    users: InvitedUser[];
    loading: boolean;
}

export const InvitesTable: FC<Props> = ({ users, loading }) => {
    const columns: TableProps<InvitedUser>['columns'] = [
        {
            key: 'id',
            dataIndex: 'id',
            title: 'CID'
        },
        {
            key: 'role',
            title: 'Роль',
            render: (_, user) => getUserOrigin(user, true)
        },
    ];

    return (
        <Table
            columns={columns}
            dataSource={users}
            loading={loading}
            scroll={{ x: true }}
        />
    )
}